import type {
  MessagingProviderSettings,
  TicketingProviderSettings,
} from './integrations.contract';

export type ProviderSettingsInput =
  | MessagingProviderSettings
  | TicketingProviderSettings;

export type ProviderSettingsLike =
  | ProviderSettingsInput
  | Record<string, unknown>;

const MESSAGING_PROVIDER_SETTING_KEYS = [
  'defaultChannelId',
  'default_channel_id',
] as const;

const TICKETING_PROVIDER_SETTING_KEYS = [
  'cloudId',
  'projectId',
  'projectName',
  'applicationProjectOverrides',
  'issueTypeName',
  'statusMappings',
  'requiredFieldDefaults',
  'optionalFieldDefaults',
] as const;

export const hasMessagingProviderSettingsKeys = (
  data: ProviderSettingsLike,
): boolean =>
  Object.keys(data).some((key) =>
    MESSAGING_PROVIDER_SETTING_KEYS.includes(
      key as (typeof MESSAGING_PROVIDER_SETTING_KEYS)[number],
    ),
  );

export const hasTicketingProviderSettingsKeys = (
  data: ProviderSettingsLike,
): boolean =>
  Object.keys(data).some((key) =>
    TICKETING_PROVIDER_SETTING_KEYS.includes(
      key as (typeof TICKETING_PROVIDER_SETTING_KEYS)[number],
    ),
  );

export const isMessagingOnlyProviderSettings = (
  data: ProviderSettingsLike,
): boolean => !hasTicketingProviderSettingsKeys(data);
